export default {"src":"/_next/static/media/beans.3855a40c.svg","height":452,"width":451,"blurWidth":0,"blurHeight":0};